var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarAlertHr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BFF255BA-A959-4B9B-9718-E0495F505D1E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-215.000000, -603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(216.000000, 604.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Phantom"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.2,
    stroke: "#FF335C",
    cx: 16,
    cy: 16,
    r: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7662505,11.2377015 C21.9766846,10.4452346 20.9055809,10 19.788704,10 C18.6718271,10 17.6007234,10.4452346 16.8111576,11.2377015 L15.9997953,12.0516628 L15.188433,11.2377015 C13.5439795,9.58798048 10.8777936,9.5879805 9.23334013,11.2377016 C7.58888664,12.8874227 7.58888662,15.562149 9.23334008,17.2118701 L10.0447024,18.0258314 L15.9997953,24 L21.9548882,18.0258314 L22.7662505,17.2118701 C23.5561871,16.4197751 24,15.3452404 24,14.2247858 C24,13.1043313 23.5561871,12.0297966 22.7662505,11.2377015 Z",
    id: "heart",
    fill: "#FF335C",
    mask: "url(#mask-2)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlertHr);
export default __webpack_public_path__ + "static/media/avatar-alert-hr.8c764ef6a2cecc1f604521de1d581eba.svg";
export { ForwardRef as ReactComponent };